import React, { ReactElement } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import { IS_PRODUCTION } from 'appConstants';
import SubHeader from 'components/SubHeader';
import { PageContent } from 'components/page';
import { usePermissions } from 'hooks';
import ForbiddenPage from 'pages/public/AccessDenied';
import { StepsLoading } from 'pages/public/Loading';
import NotFoundPage from 'pages/public/NotFoundPage';

import { Stamps, Games, Referrals, Surveys, Quizzes, RewardPromo, LandingPage } from './Campaign';

const readyForProduction = ['stamps', 'games'];

const wrapSubHeader = (campaign: ReactElement) => {
  // returns a ReactElement which is intended to be used
  // as a Route component.

  const featureTabs = [
    { key: 'stamps', label: 'Stamps' },
    { key: 'games', label: 'Games' },
    { key: 'referrals', label: 'Referrals' },
    { key: 'surveys', label: 'Surveys' },
    { key: 'quizzes', label: 'Quizzes' },
    { key: 'rewardpromo', label: 'Reward Promo' }
  ];

  const campaignNavigationTabs = [
    ...(IS_PRODUCTION ? featureTabs.filter(ft => readyForProduction.includes(ft.key)) : featureTabs)
  ];

  const Wrapper = () => {
    const location = useLocation();
    return (
      <>
        <SubHeader
          subTabs={campaignNavigationTabs}
          defaultSubTab={location.pathname.split('/').pop()}
        />
        {campaign}
      </>
    );
  };

  return <Wrapper />;
};

const Campaigns = () => {
  const { loading: permissionsLoading, canView } = usePermissions('business_intelligence');

  if (permissionsLoading) {
    return <StepsLoading />;
  }

  if (!canView) {
    return <ForbiddenPage />;
  }

  const featureRoutes = [
    {
      key: 'stamps',
      route: <Route key={'stamps'} path={`stamps`} element={wrapSubHeader(<Stamps />)} />
    },
    {
      key: 'games',
      route: <Route key={'games'} path={`games`} element={wrapSubHeader(<Games />)} />
    },
    {
      key: 'referrals',
      route: <Route key={'referrals'} path={`referrals`} element={wrapSubHeader(<Referrals />)} />
    },
    {
      key: 'surveys',
      route: <Route key={'surveys'} path={`surveys`} element={wrapSubHeader(<Surveys />)} />
    },
    {
      key: 'quizzes',
      route: <Route key={'quizzes'} path={`quizzes`} element={wrapSubHeader(<Quizzes />)} />
    },
    {
      key: 'rewardpromo',
      route: (
        <Route key={'rewardpromo'} path={`rewardpromo`} element={wrapSubHeader(<RewardPromo />)} />
      )
    }
  ];

  return (
    <PageContent style={{ overflow: 'visible' }}>
      <div className="container">
        <Routes>
          <Route index element={<LandingPage />} />
          {featureRoutes.map(r => r.route)}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </PageContent>
  );
};

export default Campaigns;
